<template>
  <div class="big">
    <DocMsg
      :isFlag="doc_msg"
      :doctorId="doctorId"
    ></DocMsg>

    <div class="page_title">助理信息列表</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox">
          <span>助理姓名</span>
          <el-input
            placeholder="请输入"
            v-model="ass_name"
            style="width: 130px; margin: 0 12px 0 5px"
            @input="search"
            clearable=""
          ></el-input>
          <span>助理手机</span>
          <el-input
            placeholder="请输入"
            v-model="ass_phone"
            style="width: 130px; margin: 0 12px 0 5px"
            @input="search"
            clearable=""
          ></el-input>
          <span>医生姓名</span>
          <el-input
            placeholder="请输入"
            v-model="doctor_name"
            style="width: 130px; margin: 0 12px 0 5px"
            clearable=""
            @input="search"
          ></el-input>
          <span>医生手机</span>
          <el-input
            placeholder="请输入"
            v-model="doctor_phone"
            style="width: 130px; margin: 0 12px 0 5px"
            clearable=""
            @input="search"
          ></el-input>
          <el-button
            type="primary"
            @click="search"
            size="medium"
          >查询</el-button>
          <el-button
            plain
            @click="reSearch"
            size="medium"
          >重置</el-button>
        </div>
        <div class="searchbox">
          <span>
            <span style="margin-right: 10px">状态</span>
            <el-radio-group
              v-model="status"
              @change="search"
            >
              <el-radio :label="''">全部</el-radio>
              <el-radio :label="1">开启</el-radio>
              <el-radio :label="0">停用</el-radio>
            </el-radio-group>
          </span>
          <span style="margin-left: 40px">
            <span style="margin-right: 10px">是否绑定歧黄助手</span>
            <el-radio-group
              v-model="bind_wx"
              @change="search"
            >
              <el-radio :label="''">全部</el-radio>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="border: solid 1px #c9cbd6; margin-top: 12px">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              prop="ass_name"
              label="助理姓名"
            ></el-table-column>
            <el-table-column
              prop="ass_phone"
              label="助理手机号"
            ></el-table-column>
            <el-table-column label="医生姓名">
              <template slot-scope="scope">
                <span
                  @click="showDocMsg(scope.row.doctor_id)"
                  style="cursor:pointer"
                >{{scope.row.doctor_name}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="doctor_phone"
              label="手机号"
            ></el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.is_status"> 开启 </span>
                <span v-else> 停用 </span>
                <el-switch
                  v-model="scope.row.is_status"
                  active-color="#669961"
                  style="margin-left: 4px"
                  @change="
                        (value) => {
                          return changeStatus(value, scope.row.bind_id);
                        }
                      "
                  :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('752')
                          : false
                      "
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column
              prop="group_total"
              label="是否绑定歧黄助手"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.bind_wx"> 是 </span>
                <span v-else> 否 </span>

              </template>
            </el-table-column>
            <el-table-column
              prop="nick_name"
              label="微信昵称"
            ></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('753')
                      : false
                  "
                  @click="toDetail(scope.row.bind_id)"
                >详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align: center">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin: 30px 0 20px 0"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import DocMsg from '../../../components/common/DocMsg.vue';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      ass_name: '',
      ass_phone: '',
      doctor_name: '',
      doctor_phone: '',
      status: '',
      bind_wx: '',
      doc_msg: false,
      doctorId: ''
    };
  },
  components: {
    DocMsg
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取用户列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        ass_name: this.ass_name,
        ass_phone: this.ass_phone,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        status: this.status,
        bind_wx: this.bind_wx
      };
      this.axios
        .post('platform/assistant/doctorassistantslists', data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list.map((item) => {
              item.is_status = item.status ? true : false;
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //重置
    reSearch() {
      this.currentPage = 1;
      this.pagesize = 10;
      this.ass_name = '';
      this.ass_phone = '';
      this.doctor_name = '';
      this.doctor_phone = '';
      this.status = '';
      this.bind_wx = '';
      this.getList();
    },
    //详情
    toDetail(bind_id) {
      this.$router.push({
        path: 'assistantdetail',
        query: {
          bind_id
        }
      });
    },
    //更改状态
    changeStatus(value, bind_id) {
      let data = {
        bind_id: bind_id,
        status: 0
      };
      let msg = '停用';
      if (value) {
        data.status = 1;
        msg = '启用';
      }

      this.$confirm(`是否${msg}该助理？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/assistant/stopDoctorAssistants', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('操作成功');
                this.getList();
              }
            });
        })
        .catch(() => {
          this.getList();
        });
    }
  },
  activated() {
    this.getList();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.searchbox {
  display: flex;
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  width: 500px;
  padding-top: 20px;
}
</style>